if (customElements && !customElements.get('accordion-list')) {
  class AccordionList extends HTMLElement {
    constructor() {
      super();

      this.onClick = this.onClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    onClick(event) {
      if (event.target.closest('.accordion__panel')) return;

      const item = event.target.closest('.accordion__item');
      if (!item || !this.contains(item)) return;

      const willOpen = !item.classList.contains('accordion__item--open');

      this.querySelectorAll('.accordion__item--open').forEach((open) => {
        this.setOpen(open, false);
      });

      if (willOpen) {
        this.setOpen(item, true);
      }
    }

    setOpen(item, open) {
      const panel = item.querySelector('.accordion__panel');
      const trigger = item.querySelector('.accordion__trigger');
      const from = panel.getBoundingClientRect().height;

      item.classList.toggle('accordion__item--open', open);
      trigger.setAttribute('aria-expanded', String(open));

      const to = open ? panel.scrollHeight : 0;

      panel.animate(
        [{ height: from + 'px' }, { height: to + 'px' }],
        { duration: 300, easing: 'ease' }
      );
    }
  }

  customElements.define('accordion-list', AccordionList);
}
